export default "__VITE_ASSET__7b02ec36__"